module.exports = __webpack_public_path__ + "img/bree-3018-09-30.47e02986.jpg";